import React from 'react';

import { breakpoints } from '../../styles/media-queries';

import { usePageDataContext } from '../../context/PageData';

import { WEB_BANNER_HEIGHT } from '../WebBanner/styles';
import {
  NAVBAR_HEIGHT_BASELINE,
  NAVBAR_HEIGHT_DESKTOP
} from '../Navbar/styles';
import {
  HEADER_HEIGHT_BASELINE,
  HEADER_HEIGHT_DESKTOP
} from '../Header/styles';

import { StyledTopSpacer, NavbarSpacer, WebBannerSpacer } from './styles';

export type Heights = Partial<Record<keyof typeof breakpoints, number>>;

export interface TopSpacerProps {
  heights?: Heights;
  bannerVisible?: boolean;
}

export function TopSpacer({ heights = {}, bannerVisible }: TopSpacerProps) {
  const { page: { hideHeader, headerType } = {} } = usePageDataContext();

  const getHeight = (): Heights => {
    switch (headerType?.sys?.contentType?.sys?.id) {
      case 'affiliateHeader':
        return heights as Heights;

      case 'header':
        return {
          0: HEADER_HEIGHT_BASELINE,
          desktop: HEADER_HEIGHT_DESKTOP
        };

      case 'header2':
      case 'variationContainer':
      default:
        return {
          0: NAVBAR_HEIGHT_BASELINE,
          desktop: NAVBAR_HEIGHT_DESKTOP
        };
    }
  };

  return !hideHeader || bannerVisible ? (
    <StyledTopSpacer className="top-spacer" data-testid="top-spacer">
      {!hideHeader && (
        <NavbarSpacer
          className="top-spacer__navbar-spacer"
          heights={getHeight()}
        />
      )}
      {bannerVisible && (
        <WebBannerSpacer
          className="top-spacer__web-banner-spacer"
          bannerHeights={{
            0: WEB_BANNER_HEIGHT,
            desktop: WEB_BANNER_HEIGHT
          }}
        />
      )}
    </StyledTopSpacer>
  ) : null;
}
